jQuery(function ($) {
    // Remove the 'no-js' <body> class
    $('html').removeClass('no-js');

    $(function () {
        var pushMenu = new mlPushMenu(
            $('.sb-menu')[0],
            $('.sb-menu--trigger')[0],
            {
                wrapper: $('.site-container')[0]
            }
        );
    });

    // Toggle body class for mobile menu
    $('.sb-menu--trigger').on('click', function () {
        $('body').addClass('mobile-menu-opened');
    });

    $(document).on('click', '.sb-pushed', function () {
        $('body').removeClass('mobile-menu-opened');
    });

    //Alert for offsite links
    $('body').on('click', '.external a, a.external', function (e) {
        var answer = confirm("You are now being directed offsite.");

        if (!answer) {
            e.preventDefault();
        }
    });

    //Disable pointer events on scroll
    var disablePointerEventsOnScroll = function () {
        var root = document.documentElement;
        var timer;

        window.addEventListener('scroll', function () {
            // User scrolling so stop the timeout
            clearTimeout(timer);
            // Pointer events has not already been disabled.
            if (!root.style.pointerEvents) {
                root.style.pointerEvents = 'none';
            }

            timer = setTimeout(function () {
                root.style.pointerEvents = '';
            }, 250);
        }, false);
    };
    disablePointerEventsOnScroll();

    // Back-to-top
    $('#action-back-to-top').on('click', function (e) {
        console.log('Has been clicked.');
        e.preventDefault();
        $('html,body').animate({
            scrollTop: 0
        }, 1000);
    });

    // degrees-filter
    $('#degrees-filter li #reset-all').click(function (e) {
        e.preventDefault();
        $("#degrees-filter .menu-partners-container li").removeClass("active");
        $(this).closest('li').addClass('active');
        $("#degrees-filter .degrees-list .table-row").removeClass("inactive").addClass("active");
    });

    $('#degrees-filter .menu-partners-container a:not(#reset-all)').click(function (e) {
        e.preventDefault();

        // Reset and add active class to clicked in menu
        $("#degrees-filter .menu-partners-container li").removeClass("active");
        $(this).closest('li').addClass('active');

        // Only show
        var grabbedId = $(this).attr('id');
        var clickedClass = '.' + grabbedId;

        $('#degrees-filter .degrees-list .table-row').removeClass('active').addClass('inactive');
        $('#degrees-filter .degrees-list .table-row' + clickedClass).removeClass('inactive').addClass('active');

    });

    // Search
    $('#trigger-search').click(function (event) {
        event.preventDefault();
        $('.search-container').show();
        $('.title-area').hide();
        $('.header-widget-area').hide();
    });
    $('#close-search').click(function (event) {
        event.preventDefault();
        $('.search-container').hide();
        $('.title-area').show();
        $('.header-widget-area').show();
    });

    $('#case-study-filter li #reset-all').click(function (e) {
        e.preventDefault();
        var sectionWrap = $('.case-studies .section-wrap');
        var sectionColumns = $('.case-studies .section-wrap .col');

        $("#case-study-filter li").removeClass("active");
        $(this).closest('li').addClass('active');

        sectionColumns.removeClass('inactive').addClass('active');
        sectionWrap.find('.col:nth-of-type(3n + 1)').css('margin-left', '0');
        sectionWrap.find('.col:nth-of-type(3n + 2)').css('margin-left', '2%');
        sectionWrap.find('.col:nth-of-type(3n + 3)').css('margin-left', '2%');
    });

    // Toggle case studies
    $('#case-study-filter li a:not("#reset-all")').click(function (e) {

        e.preventDefault();

        // Not the reset button
        $('.case-studies .section-wrap .col').removeClass('inactive active');

        $("#case-study-filter li").removeClass("active");
        $(this).closest('li').addClass('active');

        var grabbedId = $(this).attr('id');
        var clickedClass = '.' + grabbedId;

        console.log(clickedClass);

        var sectionWrap = $('.case-studies .section-wrap');
        var classItems = $('.case-studies .section-wrap .col' + clickedClass);

        function remove_add_classes() {
            if (classItems.hasClass('active')) {
                $('.case-studies .section-wrap .col').removeClass('inactive');
                classItems.removeClass('active');
                sectionWrap.find('.col:nth-of-type(3n + 1)').css('margin-left', '0');
                sectionWrap.find('.col:nth-of-type(3n + 2)').css('margin-left', '2%');
                sectionWrap.find('.col:nth-of-type(3n + 3)').css('margin-left', '2%');
            } else {
                $('.case-studies .section-wrap .col').removeClass('active').addClass('inactive');
                classItems.removeClass('inactive').addClass('active');
            }
        }

        remove_add_classes();

        // Only need to do this over $gt-medium from Sass
        if ($(window).width() > 769) {

            sectionWrap.find('.col.active:nth-of-type(3n + 1)').css('margin-left', '0');
            sectionWrap.find('.col.active:nth-of-type(3n + 2)').css('margin-left', '2%');
            sectionWrap.find('.col.active:nth-of-type(3n + 3)').css('margin-left', '2%');

        }

    });

    if ($(window).width() < 769) {
        $('#case-study-filter ul').on("click", ".init", function() {
            $('#case-study-filter ul').children('li:not(.init)').addClass('show-inactive');
            $('#case-study-filter ul').addClass('show-dropdown');
        });

        var allOptions = $("#case-study-filter ul").children('li:not(.init)');
        $("#case-study-filter ul").on("click", "li:not(.init)", function() {
            $("#case-study-filter ul li").removeClass('show-inactive active init');
            $(this).addClass('active init');
            $('#case-study-filter ul').removeClass('show-dropdown');
        });
    }

    // Facilities toggle
    $('.facilities-toggle .menu-facilities-container a').click(function (e) {
        e.preventDefault();

        // Reset and add active class to clicked in menu
        $(".page-id-2669 .page-section .menu-facilities-container li").removeClass("active");
        $(this).closest('li').addClass('active');

        // Only show
        var grabbedId = $(this).attr('id');
        var clickedClass = '.item-' + grabbedId;

        $('.facilities-toggle .excerpts .single-facility').removeClass('active');
        $('.facilities-toggle .excerpts .single-facility' + clickedClass).addClass('active');

    });

    // Alliance -- Training toggle
    $('.training-toggle .menu-training-container a').click(function (e) {
        e.preventDefault();

        // Reset and add active class to clicked in menu
        $(".site-container .page-section .menu-training-container li").removeClass("active");
        $(this).closest('li').addClass('active');

        // Only show
        var grabbedId = $(this).attr('id');
        var clickedClass = '.item-' + grabbedId;

        $('.training-toggle .excerpts .single-training').removeClass('active').addClass('inactive');
        $('.training-toggle .excerpts .single-training' + clickedClass).removeClass('inactive').addClass('active');

    });
    // Default state
    // -- single trainings are inactive
    $('#training-filter li #reset-all').click(function (e) {
        e.preventDefault();
        $("#training-filter .menu-degrees-container li").removeClass("active");
        $(this).closest('li').addClass('active');
        $("#training-filter .excerpts .single-training").addClass("inactive").removeClass("active");
        $(".excerpts .description-content").show();
    });
    // If anything else but reset is clicked, hide the description content
    $('#training-filter li :not(#reset-all)').click(function (e) {
        e.preventDefault();
        $(".excerpts .description-content").hide();
    });

});
